// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { InputBox } from '@imprivata-cloud/components';
import { Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import SamlConfigSection from './SamlConfigSection';

export interface HyperdriveFormValues {
  appUsernameAdMatch: boolean | null;
  interconnectUrl: string;
  // REQ-006 / AC-019: nested per `Form.Item name={['epicAppLockConfig', …]}`.
  // Either sub-key may be absent when the admin has not selected a value.
  epicAppLockConfig?: { sharedWorkstation?: string; privateWorkstation?: string };
}

interface HyperdriveConfigFormProps {
  appDisplayName: string;
  isEdit: boolean;
  idpIssuer: string | null;
  redirectUri: string;
  idpCertificate: string;
  tenantId: string;
}

const TRANSLATION_ROOT = 'apps.app-modal';

const HyperdriveConfigForm: React.FC<HyperdriveConfigFormProps> = ({
  appDisplayName,
  isEdit,
  idpIssuer,
  redirectUri,
  idpCertificate,
  tenantId,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {/* REQ-018 / AC-016 / AC-027a: Display Name is read-only, bound
          to the integration record, and NOT registered with the AntD
          form (no `name` prop on the wrapping Form.Item). The Form.Item
          wrap is layout-only — it inherits AntD's default 24px bottom
          margin so Display Name sits on the same vertical rhythm as
          the mapping Select and every other field in the modal (F-7). */}
      <Form.Item className="hyperdrive-display-name">
        <InputBox
          label={t(`${TRANSLATION_ROOT}.display-name`)}
          aria-label="display-name"
          value={appDisplayName}
          disabled
        />
      </Form.Item>

      <Divider />

      <SamlConfigSection
        isEdit={isEdit}
        idpIssuer={idpIssuer}
        redirectUri={redirectUri}
        idpCertificate={idpCertificate}
        tenantId={tenantId}
      />
    </>
  );
};

export default HyperdriveConfigForm;
